import { FilePdfOutlined } from '@ant-design/icons';
import { Menu as AntdMenu } from 'antd';

import { useAppSelector } from 'app/store';
import { uiModel } from 'entities/ui';

import styles from '../index.module.scss';

const Manual = () => {
  const { Item } = AntdMenu;
  const { isCollapsed } = useAppSelector(uiModel.Layout.selectors.selectLayout);
  return (
    <Item
      key="webmanual"
      icon={<FilePdfOutlined className={isCollapsed ? styles.collapsed_icon : styles.icon} />}
      className={styles.manual_link}
      title="Инструкция"
    >
      <a href="https://zupnrb.niaep.ru/public/User%20web%20HR_31.10.2022.pdf" target="_blank" title="">
        <p>Инструкция</p>
      </a>
    </Item>
  );
};

export default Manual;
